module.exports = __webpack_public_path__ + "static/media/nextgen-logo.8f060faa.png";